import InputComponent from "V2.0/components/InputComponent";

export default TriggerCoachLLMBased;

function TriggerCoachLLMBased(props) {
  const { coachTriggerState, setCoachTriggerState, isUnlocked } = props;

  const handleChange = function (e) {
    const value = e.target.value;

    setCoachTriggerState((prev) => {
      return {
        ...prev,
        triggerPrompt: value,
      };
    });
  };

  return (
    <div>
      <InputComponent
        type="textArea"
        label="Trigger Prompt"
        value={coachTriggerState.triggerPrompt}
        onChange={handleChange}
        style={{ fontSize: "13px", height: "200px" }}
        disabled={!isUnlocked}
      />
    </div>
  );
}
